import React from 'react'

const RestrictedApplications = () => (
  <div className="restricted-applications">
    Applications
  </div>
)

export default RestrictedApplications